const PATHS = {
	SIGNUP: '/auth/signup',
	LOGIN: '/auth/login',
	LOGOUT: '/auth/logout',
	USER: '/auth/user',
	TOKEN_VERIFICATION: '/auth/tokenVerfication',
	VERIFY_EMAIL: '/auth/verify-email',
	FORGOT_PASSWORD: '/public/forgot-password',
	RESET_PASSWORD: '/public/reset-password',
	SUBSCRIPTION_LIST: '/public/subscriptionList',
	EDIT_PROFILE: '/user/edit-profile',
	DELETE_USER: '/user/delete',
	CHANGE_PASSWORD: '/user/change-password',
	GENERATE_PAYMENT_LINK: '/payment/generate-payment-link',
	FREE_TRIAL: '/user/start-free-trial',
	ADD_PATIENT: '/patient/add-patient',
	EDIT_PATIENT: '/patient/edit-patient',
	PLAN_DETAILS: '/user/subscription-plan',
	SUBSCRIPTION_PLAN_CANCEL: '/payment/generate-cancel-subscription-link',
	PATIENT_LIST: '/patient/list',
	PATIENT_FETCH: '/patient/',
	CASE_LIST: '/note/case-list',
	NOTE_LIST: '/note/note-list',
	IN_PROGRESS: '/user/inProgress-note-list',
	CASE_UPDATE: '/note/edit-case',
	CASE_ADD: '/note/add-note',
	DELETE_PATIENT: '/patient/delete-patient/',
	NOTEDETAILS_UPDATE: '/note/updateNoteDetails',
	SOAP_DELETE: '/note/delete-note/',
	NOTE_DETAIL: '/note',
	NOTE_DOWNLOAD: '/note/downloadPDF',
	CALENDAR_DETAIL: '/note/patient/get-calendar',
	CALENDAR_DETAIL_DAY: '/note/patient/get-calendar-day',
	FORM_ID: '/form/list',
	FROM_VIEW_LIST: '/form/noteList',
	FROM_CREATE_FORM: '/form/add-note-form',
	FORM_CREATE_VIEW: '/form/NoteformList',
	FORM_VIEW_PDF: '/form/downloadNoteFormPdf',
	USER_FORM_LIST: '/user-form/list',
	RESEND_VERIFICATION_EMAIL: '/auth/resend-verification-email',
};
export default PATHS;
